import React from "react";
import formatDate from "../../../../helpers/formatDate";
import getSchoolAuthorNameSelector from "../../../../state/selectors/SchoolSelectors/getSchoolAuthorNameSelector";
import getSchoolPostCustomDateSelector from "../../../../state/selectors/SchoolSelectors/getSchoolPostCustomDateSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

const SchoolDate: React.FC = () => {
    const postDate = useSelector((state: Store) => getSchoolPostCustomDateSelector(state));
    const authorName = useSelector((state: Store) => getSchoolAuthorNameSelector(state));
    if (!postDate && !authorName) return null;
    return (
        <Wrapper>
            {postDate ? (
                <p>
                    <strong>Data</strong>: {formatDate(postDate)}
                </p>
            ) : null}
            {authorName ? (
                <p>
                    <strong>Autore</strong>: {authorName}
                </p>
            ) : null}
        </Wrapper>
    );
};

export default SchoolDate;

const Wrapper = styled.div`
    font-style: italic;
    position: absolute;
    right: 4rem;
    bottom: 6.5rem;
    text-align: right;
    @media print {
        position: fixed;
        right: 0.5rem;
        bottom: 3.5rem;
        font-size: 0.8rem;
    }
`;
